import { P2GBox, useP2GMediaQueryOnly } from '@parcel2go/core-ui';
import { Outlet } from 'react-router-dom';
import Banners from '~/apps/smartsend/components/content/Banners';
import Notifications from '~/apps/smartsend/components/notifications/Notifications';
import Edit from '~/apps/smartsend/components/smartsend/edit/Edit';
import WalkthroughPrompt from '~/apps/smartsend/components/smartsend/onboarding/WalkthroughPrompt';
import Tasks from '~/apps/smartsend/components/task/Tasks';
import { SmartSendTasks } from './smartsend-tasks';
import { Navigation } from '~/components/nav/nav';
import { NavExperienceProvider } from '~/components/nav/nav-experience';

// The existing (SmartSend) experience chrome, wrapping all current routes at the
// prefix root. Lifted verbatim out of my-account.tsx so the consumer view can render
// a different sidebar; behaviour and markup are unchanged.
export default function Component() {
  const isXs = useP2GMediaQueryOnly('xs');
  return (
    <NavExperienceProvider experience="business">
      <Banners tab={''} isXs={isXs} />
      <P2GBox sx={(t) => ({ backgroundColor: t.palette.grey?.A100 })}>
        <Navigation isXs={isXs}>
          <Outlet />
        </Navigation>
      </P2GBox>
      <Notifications />
      <Tasks filterKey="" />
      <Edit />
      <WalkthroughPrompt tab={''} isXs={isXs} />
      <SmartSendTasks />
    </NavExperienceProvider>
  );
}

Component.displayName = 'SmartSend';
